import { forwardRef } from 'react';
import { Bar, BarChart, CartesianGrid, Legend, ReferenceLine, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { BarCharts, ChartsProps, GraphicsDomain } from '../../interfaces/Indicator';
import useDataKey from '../../hooks/useDataKey';
import CustomToolTip from './CustomToolTip';
import NotDataDisplay from '../Cards/NotDataDisplay';
import { messages } from '../../utils/const';
import { useChartDomains } from '../../hooks/useChartDomains';
import { useChartOrientation } from '../../hooks/useChartOrientation';

const StackedBarChart = forwardRef<HTMLDivElement, Omit<ChartsProps, 'typeOfIndicador'>>(({ data, variable_analisis, range, errorsNoData, filters, orientation }, ref) => {
    const { domainYLeft } = useChartDomains(
        data,
        variable_analisis,
        null,
        range!,
        null
    );

    const { dataKey } = useDataKey(data, filters);

    const { layout, xAxisProps, yAxisProps, referenceLineProps } = useChartOrientation({
        orientation,
        valueAxis: { domain: domainYLeft, ticks: range?.ticks ?? undefined },
    });

    return (
        <>
            <ResponsiveContainer width='100%' height="100%" ref={ref}>
                <BarChart
                    data={data}
                    layout={layout}
                    margin={{
                        top: 10,
                        right: 30,
                        left: 20,
                        bottom: 5,
                    }}
                >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis {...xAxisProps} />
                    <YAxis  {...yAxisProps} />
                    <Tooltip
                        content={<CustomToolTip />}
                        wrapperStyle={{ pointerEvents: 'auto', zIndex: 50 }}
                        isAnimationActive={false}
                    />
                    <Legend
                        wrapperStyle={{ fontSize: '0.875rem' }}
                        align='center'
                    />
                    <ReferenceLine
                        {...referenceLineProps}
                        stroke="#555C62"
                        strokeWidth="2"
                    />
                    {dataKey?.map((key, index) => (
                        <Bar
                            name={key.key.split('-').map(entity => entity.split(':')[1]).join('/') ?? "-"}
                            dataKey={key.key}
                            stackId="a"
                            fill={key.color}
                            key={index}
                            isAnimationActive={false}
                        />
                    ))}
                </BarChart>
            </ResponsiveContainer>
            {errorsNoData ? <NotDataDisplay message={messages.chart} /> : null}
        </>
    );
});

export default StackedBarChart;